/**
 * 模块: 品牌竞争分析主容器
 * 职责: 组装品牌竞争分析页面的各个组件
 * 限制: 文件<280行
 */

import React from 'react';
import { Card, Spin, Typography, Row, Col, Statistic } from 'antd';
import { ApartmentOutlined, FireOutlined } from '@ant-design/icons';
import BrandNetworkGraph from '../../components/BrandNetworkGraph';
import { useBrandCompetition } from './useBrandCompetition';
import { NetworkControls } from './NetworkControls';
import { CompetitionTable } from './CompetitionTable';
import './BrandCompetition.css';

const { Title, Text } = Typography;

const BrandCompetition: React.FC = () => {
  const {
    loading,
    generating,
    skus,
    periods,
    selectedSKU,
    setSelectedSKU,
    selectedPeriod,
    setSelectedPeriod,
    minFrequency,
    setMinFrequency,
    networkData,
    fetchNetworkData,
    handleGenerateNetwork,
  } = useBrandCompetition();

  return (
    <div className="brand-competition-container">
      <div className="brand-competition-header">
        <Title level={2}>
          <ApartmentOutlined /> 品牌竞争分析
        </Title>
        <p>可视化品牌间的竞争关系，分析市场格局</p>
      </div>

      <NetworkControls
        skus={skus}
        periods={periods}
        selectedSKU={selectedSKU}
        selectedPeriod={selectedPeriod}
        minFrequency={minFrequency}
        generating={generating}
        loading={loading}
        onSKUChange={setSelectedSKU}
        onPeriodChange={setSelectedPeriod}
        onFrequencyChange={setMinFrequency}
        onGenerate={handleGenerateNetwork}
        onRefresh={fetchNetworkData}
      />

      {networkData && (
        <Card className="stats-card" style={{ marginBottom: 16 }}>
          <Row gutter={16}>
            <Col span={8}>
              <Statistic
                title="品牌总数"
                value={networkData.stats.total_brands}
                prefix={<ApartmentOutlined />}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="竞争关系数"
                value={networkData.stats.total_competitions}
                prefix={<FireOutlined />}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="自有品牌"
                value={networkData.stats.own_brand}
                valueStyle={{ fontSize: 18 }}
              />
            </Col>
          </Row>
        </Card>
      )}

      <Spin spinning={loading}>
        {networkData && networkData.nodes.length > 0 ? (
          <>
            <BrandNetworkGraph
              nodes={networkData.nodes}
              edges={networkData.edges}
              ownBrand={networkData.stats.own_brand}
            />
            <CompetitionTable edges={networkData.edges} />
          </>
        ) : (
          <Card>
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <Text type="secondary">
                {selectedSKU
                  ? '暂无品牌竞争数据，请点击"生成网络"按钮生成分析'
                  : '请先选择一个SKU'}
              </Text>
            </div>
          </Card>
        )}
      </Spin>
    </div>
  );
};

export default BrandCompetition;

